export default {
  getBrandingCode: (state) => state.brandingCode,
};
